import PubNub from 'pubnub';
import _ from 'lodash';

import { getPubNubAuthKey } from 'admin/resources';

const KEYS = {
	publishKey: 'pub-c-7ce09e41-abc2-41d8-9ef4-a12050b79bb9',
	subscribeKey: 'sub-c-23e7349a-6310-11e8-b753-ce5efc28367f',
};

const PN_AUTH_KEY_INFO = 'magnitogorsk';
export const PN_STORY_KICK_EVENT = 'story.kick';

export type PNMessageEventType = {
	message: {
		event: string;
		memberId: string;
		memberName: string;
		senderId: string;
	};
};

type JoinParams = {
	storyId: string;
	organizationId: string;
	userId: string;
	onMessage?: (event: any) => void;
};

class PubnubFacade {
	private instance: PubNub;
	private _checkAuthKeyExpirationIntervalID: number | null;
	private _params: Partial<JoinParams>;
	private _authKeyInfo: {
		orgId?: string;
		key?: string;
		createdAt?: number;
	};

	static EVENTS = {
		STORY_KICK: 'story.kick',
	};

	constructor() {
		if (localStorage) {
			JSON.parse(localStorage.getItem(PN_AUTH_KEY_INFO) ?? '{}');
		}
		this._authKeyInfo = JSON.parse(localStorage.getItem(PN_AUTH_KEY_INFO) ?? '{}');
		this._params = {};
		this._checkAuthKeyExpirationIntervalID = null;
	}

	getAuthKey = async (organizationId: string) => {
		try {
			const response = await getPubNubAuthKey.params({ organizationId }).send();

			if (response.body?.success) {
				this._authKeyInfo = {
					key: response.body?.result?.authKey || '',
					orgId: organizationId,
					createdAt: Date.now(),
				};

				if (localStorage) {
					localStorage.setItem(PN_AUTH_KEY_INFO, JSON.stringify(this._authKeyInfo));
				}
			} else {
				throw new Error('something went wrong');
			}
		} catch (err) {
			console.info('getAuthKey Error', err);
		}
	};

	isAuthKeyExpired = () => {
		const now = Date.now();
		const diff = now - (this._authKeyInfo.createdAt || 0);

		return Math.floor(diff / 1000 / 60 / 60) > 20;
	};

	join = async (params: JoinParams) => {
		this.disconnect();
		this._params = params;

		if (
			_.isEmpty(this._authKeyInfo) ||
			this._authKeyInfo.orgId !== params.organizationId ||
			!this._authKeyInfo.key ||
			this.isAuthKeyExpired()
		) {
			await this.getAuthKey(params.organizationId);
		}

		const { organizationId, storyId, userId, onMessage = null } = this._params;

		if (!organizationId || !storyId || !userId || !this._authKeyInfo.key) {
			console.info('Error! Params missing for init pubnub');
		} else {
			this.instance = new PubNub({
				publishKey: KEYS.publishKey,
				subscribeKey: KEYS.subscribeKey,
				uuid: userId,
				authKey: this._authKeyInfo.key,
			});

			if (onMessage) {
				this.instance.addListener({
					message: onMessage,
				});
			}

			this.instance.subscribe({
				channels: [`${organizationId}.${storyId}`],
			});

			this._checkAuthKeyExpirationIntervalID = window.setInterval(() => {
				if (this.isAuthKeyExpired()) {
					this.join(this._params as JoinParams);
				}
			}, 60 * 60 * 1000);
		}
	};

	disconnect = () => {
		if (this.instance) {
			this.instance.unsubscribeAll();
			this.instance.destroy();
			this.instance = null;
		}

		if (this._checkAuthKeyExpirationIntervalID) {
			clearInterval(this._checkAuthKeyExpirationIntervalID);
		}
	};
}

export default new PubnubFacade();
